export default function attr(el, ruleName, val) {
  el.setAttribute(ruleName, val);
}
